import React from 'react';
function LayersForeground({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        id="Stroke"
        d="M18 15.5V17C18 17.5523 17.5523 18 17 18H7C6.44772 18 6 17.5523 6 17V7C6 6.44772 6.44772 6 7 6H8.5M15 18V20C15 20.5523 14.5523 21 14 21H4C3.44772 21 3 20.5523 3 20V10C3 9.44772 3.44772 9 4 9H6M9.5 14.5L20.5 3.5M13 15L21 7.5M16.5 15L21 10.5M17 3L9 11M13 3L9 7M10 15H20C20.5523 15 21 14.5523 21 14V4C21 3.44772 20.5523 3 20 3H10C9.44772 3 9 3.44772 9 4V14C9 14.5523 9.44772 15 10 15Z"
      />
    </svg>
  );
}

export default LayersForeground;
